<template>
    <div class="main-content detail success" v-cloak v-if="event_loaded">
        <trial-over @close-modal="hide_trial_modal" v-if="trial_modal_shown" :shown="trial_modal_shown"></trial-over>

        <div class="main-content-container" v-if="event && event.tasks && event.tasks.length === 0">
            <div class="detail-success">
                <div class="detail-success-icon active">
                    <span class="icon icon-tasks"></span>
                </div>
                <div class="detail-success-title">
                    Congrats, <br />
                    new event created!
                </div>
                <p class="detail-success-sub" v-cloak>
                    Now it's time to next steps:
                </p>
                <div class="btn-container">
                    <a href="javascript:{}" @click="go_to_task" :class="{ 'btn-default': true, disabled: locked }"
                        >+ Add task</a
                    >
                    <a @click="go_to_guests" href="javascript:{}" :class="{ 'btn-default': true, disabled: locked }"
                        >+ Invite guests</a
                    >
                    <a v-if="false" href="javascript:{}" :class="{ 'btn-default': true, disabled: locked }"
                        >Combine menu</a
                    >
                </div>
            </div>
        </div>
        <div v-else class="">
            <div class="container">
                <div class="events-group-top">
                    <div class="deadline" v-if="deadline_items && deadline_items.length === 1">
                        {{ deadline_items.length }} deadline
                    </div>
                    <div class="deadline" v-if="deadline_items && deadline_items.length > 1">
                        {{ deadline_items.length }} deadlines
                    </div>
                    <a @click="go_to_task" href="javascript:{}" class="btn btn-primary">+ Add task</a>
                </div>

                <div class="events" style="padding-top:0 !important;">
                    <div class="events-group todo" v-if="todo_items && todo_items.length > 0">
                        <div class="events-group-header">
                            <div align="center" class="events-group-header-icon">
                                <span>T</span>
                            </div>
                            TODO
                        </div>
                        <a
                            class="events-group-item"
                            v-for="item in todo_items"
                            href="javascript:{}"
                            @click="redirect_to_task(item.id)"
                        >
                            <div class="events-group-item-header">{{ item.name }}</div>
                            <div class="events-group-item-content">
                                <div
                                    v-if="item.deadline"
                                    :class="{
                                        'events-group-item-content--date': true,
                                        red:
                                            moment(item.deadline).format('DD.MM') === moment(new Date()).format('DD.MM')
                                    }"
                                >
                                    {{ moment(item.deadline).format("dd")[0] }}
                                    {{ moment(item.deadline).format("DD.MM, HH:mm") }}
                                </div>
                            </div>
                        </a>
                    </div>
                    <div class="events-group done" v-if="done_items && done_items.length > 0">
                        <div class="events-group-header is-current">
                            <div class="events-group-header-icon">
                                <span>D</span>
                            </div>
                            DONE
                        </div>
                        <a
                            class="events-group-item"
                            v-for="done_item in done_items"
                            href="javascript:{}"
                            @click="redirect_to_task(done_item.id)"
                        >
                            <div class="events-group-item-header">
                                {{ done_item.name }}
                            </div>
                            <div class="events-group-item-content">
                                <div class="events-group-item-content--date" v-if="done_item.done_date">
                                    Done: {{ moment(done_item.done_date).format("dd")[0] }}
                                    {{ get_date(done_item.done_date) }}
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import router from "@/router";
import moment from "moment";
import TrialOver from "./../trial-over-modal.vue";

export default {
    name: "event",
    components: { TrialOver },
    computed: {
        ...mapState("StoreEvent", ["event", "event_loaded", "active_event"]),
        ...mapState("StoreEvent", ["global_errors"]),
        ...mapState(["is_logged_in", "user"]),

        todo_items() {
            if (this.event.tasks && this.event.tasks.length > 0) {
                return this.event.tasks.filter(item => {
                    return item.status === "in_progress";
                });
            } else {
                return [];
            }
        },
        deadline_items() {
            if (this.event.tasks && this.event.tasks.length > 0) {
                return this.event.tasks.filter(item => {
                    return (
                        item.status === "in_progress" &&
                        item.deadline &&
                        moment(item.deadline).format("DD.MM") === moment(new Date()).format("DD.MM")
                    );
                });
            } else {
                return [];
            }
        },
        done_items() {
            if (this.event.tasks && this.event.tasks.length > 0) {
                return this.event.tasks.filter(item => {
                    return item.status === "done";
                });
            } else {
                return [];
            }
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.set_unlocked();
            vm.set_active_sub_tab("tasks");
            vm.get_logged_in_user();
            next();
        });
    },
    mounted() {
        this.get_current_event(this.$route.params.id);
        this.get_logged_in_user();
    },
    data() {
        return {
            trial_modal_shown: false,
            locked: false
        };
    },
    methods: {
        ...mapActions("StoreEvent", ["get_event"]),
        ...mapMutations("StoreEvent", ["set_active_sub_tab"]),
        ...mapActions(["get_logged_in_user"]),

        get_current_event(event_id) {
            this.get_event(event_id);
        },
        set_unlocked() {
            this.locked = false;
        },
        hide_trial_modal() {
            this.trial_modal_shown = false;
        },
        get_date(date) {
            var language;
            if (window.navigator.languages) {
                language = window.navigator.languages[0];
            } else {
                language = window.navigator.userLanguage || window.navigator.language;
            }
            let updated_at = moment(date + "+0000");
            updated_at.locale(language);
            let updated_at_date = updated_at.format("DD.MM, HH:mm");
            return updated_at_date;
        },
        redirect_to_task(task_id) {
            this.locked = true;
            router.push({ path: "/events/" + this.event.id + "/tasks/" + task_id });
        },
        go_to_task() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                this.locked = true;
                this.set_active_sub_tab("tasks");
                router.push({ path: "/events/" + this.event.id + "/tasks/add" });
            } else {
                this.trial_modal_shown = true;
            }
        },
        go_to_guests() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                this.locked = true;
                this.set_active_sub_tab("guests");
                if (this.event.id) {
                    console.log(this.event.id);
                    router.push({ path: "/events/" + this.event.id + "/guests" });
                }
            } else {
                this.trial_modal_shown = true;
            }
        }
    }
};
</script>
<style scoped>
.todo .events-group-item-header,
.done .events-group-item-header {
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 2.4rem;
    letter-spacing: 0.03em;
    flex: 1;
}

.deadline {
    font-weight: normal;
    font-size: 1.1rem;
    line-height: 1.6rem;
    display: flex;
    align-items: center;
    letter-spacing: 0.05em;
    color: #d30000;
}

.done .events-group-item-content,
.done .events-group-item-header {
    opacity: 0.4;
}

[v-cloak] {
    display: none;
}

.events {
    height: initial;
}

.events-group-top {
    margin-top: -2.4rem;
    display: flex;
    justify-content: center;
    margin-bottom: 3.2rem;
    align-items: center;
}

@media (max-width: 82rem) {
    .main-content {
        height: 60vh;
        overflow: auto;
    }
}

[v-cloak] {
    display: none;
}

.events-group-top .btn-primary {
    margin-left: auto;
    padding: 0.4rem 1.2rem;
}
</style>
